/**
 * OVERRIDE SearchInput.jsx
 * REASON: Special template for displaying this component
 */

import SearchInput from '../../../../../../../components/Blocks/Search/components/SearchInput';

export default SearchInput;
